import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import { ginnyLink, yohoLink, mmLink, directionsLink, PhoneLink, EmailLink, yelpLink } from '../Shared/Links'
import MailChimp from '../Shared/Mailchimp'
import Social from '../Shared/Social'
import ginnyLogo from '../../assets/images/logoGinnyLane.png'
import yohoLogo from '../../assets/images/logoYoho.png'
import mmLogo from '../../assets/images/logoMileMarker.png'

class Footer extends Component {
  render() {
    return (
      <div className="fullSec footWrap">
        <div className="famLogos">
          <div className="sectionWrap medDef">
            <h3>Check out our other <br/>AMAZING restaurants!</h3>
            <div class="blockLoop flexGroup align-center">
              <div className="item short gl">
                <a href={ginnyLink} target="_blank" rel="noopener noreferrer" className="logoLink">
                  <img src={ginnyLogo} alt="Ginny Lane Bar & Grill Logo" />
                </a>
              </div>
              <div className="item tall yoho">
                <a href={yohoLink} target="_blank" rel="noopener noreferrer" className="logoLink">
                  <img src={yohoLogo} alt="Yoho Rum and Tacos Logo" />
                </a>
              </div>
              <div className="item short mm">
                <a href={mmLink} target="_blank" rel="noopener noreferrer" className="logoLink">
                  <img src={mmLogo} alt="Mile Marker 158 Dockside Logo" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="fullSec mainFooter">
          <div className="sectionWrap medDef">
            <div className="mfItem info1">
              <div className="inner">
                <h4>Contact Information</h4>
                <p><PhoneLink /></p>
                <p><EmailLink /></p>
                <p>4790 Main Street Suite F 108-B<br/> Orange Beach, Al 36561</p>
                <a href={directionsLink} target="_blank" rel="noreferrer" className="textLink">Get Directions</a>
              </div>
            </div>

            <div className="mfItem info2">
              <h4>Hours of Operation</h4>
              <div className="hours">
                <p>Sunday-Wednesday: 11am-9pm<br/>
                Thursday-Saturday: 11am-10pm</p>
              </div>
              <Social />
              <a href={yelpLink} target="_blank" rel="noreferrer" className="vgLink rev small">Reservations</a>
            </div>

            <div className="mfItem chimp">
              <div className="inner">
                <MailChimp />
              </div>
            </div>
          </div>
        </div>

        <div id="copyright-container" className="fullSec copyRow">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-xs-12">
                <p>
                  &copy; {new Date().getFullYear()} All rights reserved. Design 
                  by <a href="http://hsdesignhouse.com" target="_blank" rel="noopener noreferrer">High Seas Design House.</a>                    
                </p>
              </div>
              <div className="col-md-6 col-xs-12">
                <ul className="breadcrumb footer-breadcrumb">
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/about">About</Link></li>
                  <li><Link to="/contact">Contact</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default Footer